'use strict';

var App = require('app');
var AppState = require('app_state');
var Utils = require('models/utils');
var Consts = require('consts');

var Value = Backbone.Model.extend({
    defaults: {
        modelType: 'value',
        unit: '',
    },

    initialize: function (options) {
        Utils.SelectableModel.applyTo(this);
        this.device = options.device;
    },

    urlRoot: function () {
        var deviceID = this.get('device') || this.collection.deviceID;
        return '/api/v1/devices/' + deviceID + '/values';
    },

    getAddress: function () {
        return this.get('type') + '_' + this.get('nr');
    },

    getRawValue: function () {
        return this.get('data')[this.getAddress()];
    },

    isOutdoorSensorDataPoint: function () {
        return this.get('nr') == 10;
    },
});

var isRegHK1 = function (value) {
    var category = AppState.getDeviceInfo(value.device).category;
    if (value.attributes) {
        // might not exist after serialization
        value = value.attributes;
    }
    // TODO: support heating circuits other than HK1
    return value.nr === 1000 && value.type === 'MBR' && category === Consts.Category.Controller;
};

var ValueCollection = Backbone.Collection.extend({
    model: Value,
    comparator: 'name',

    initialize: function (options) {
        this.deviceID = options.deviceID || '';
        Utils.SelectableCollection.applyTo(this, options);
    },

    url: function () {
        return '/api/v1/devices/' + this.deviceID + '/values';
    },

    getByAddress: function (nr, type) {
        return this.findWhere({ nr: nr, type: type });
    },

    cleanNonModbusData: function () {
        this.each(function (e) {
            var valueType = e.get('type');
            if (!Consts.ValueTypesVisible[valueType]) {
                e.attributes.nr = e.attributes.length = e.attributes.update_class = '--';
            }
        });
    },

    // getAsResponse mocks the response of a request to the valuespecs, based on the collection's models.
    getAsResponse: function (category) {
        var dataPoints = {};
        var types = [];
        this.each(function (value) {
            var v = $.extend(true, {}, value);
            v.set('group', category);
            if (!dataPoints[v.get('type')]) {
                dataPoints[v.get('type')] = [];
                types.push(v.get('type'));
            }
            dataPoints[v.get('type')].push(v.attributes);
        });

        var fakeResponse = [];
        _.each(types, function (t) {
            fakeResponse.push({
                name: Consts.ValueTypes[t] || t,
                values: dataPoints[t],
            });
        });
        return fakeResponse;
    },
});

var fromSpec = function (deviceID, spec) {
    return new Value({
        device: deviceID || 0,
        spec: parseInt(spec.id) || 0,
        value_ref: spec.value_ref || '',
        name: spec.name,
        type: spec.type,
        nr: spec.nr,
        length: spec.length,
        min: spec.min,
        max: spec.max,
        unit: spec.unit,
        format: spec.format,
        update_class: spec.update_class,
        is_readonly: spec.is_readonly,
        is_unit_fixed: spec.is_unit_fixed || false,
        display_unit: spec.display_unit || '',
    });
};

var API = {
    getValues: function (deviceID) {
        var valueList = new ValueCollection({ deviceID: deviceID });
        var defer = $.Deferred();

        valueList.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    refreshValues: function (id) {
        var defer = $.Deferred();
        App.ajax({
            method: 'GET',
            url: '/api/v1/devices/' + id + '/values/refresh',
            success: function () {
                defer.resolve();
            },
            error: function () {
                defer.resolve();
            },
        });

        return defer.promise();
    },

    getValueConfiguration: function (deviceRegisterMap) {
        var d = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/values/config',
            data: JSON.stringify({ values: deviceRegisterMap }),
            success: function (result) {
                d.resolve(result);
            },
            error: function (result) {
                d.resolve(result);
            },
        });

        return d.promise();
    },

    getValuesWriteInfo: function (deviceID, nr) {
        return App.ajaxDeferred({
            method: 'GET',
            url: '/api/v1/devices/' + deviceID + '/values/' + nr + '/write-info',
            success: function (result) {
                return result;
            },
            error: function (result) {
                return undefined;
            },
        });
    },

    getValuesMulti: function (ids) {
        var d = $.Deferred();
        var valueList = new ValueCollection({});
        valueList.fetch({
            method: 'POST',
            url: '/api/v1/devices/values/config-multi',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({ devices: ids }),
            success: function (result) {
                d.resolve(result);
            },
            error: function (result) {
                d.resolve(result);
            },
        });

        return d.promise();
    },
};

App.reqres.setHandler('device:values', function (id) {
    return API.getValues(id);
});

App.reqres.setHandler('device:values:write-info', function (deviceID, nr) {
    return API.getValuesWriteInfo(deviceID, nr);
});

App.reqres.setHandler('devices:values', function (ids) {
    return API.getValuesMulti(ids);
});

App.reqres.setHandler('device:values:refresh', function (id) {
    return API.refreshValues(id);
});

App.reqres.setHandler('register:configuration', function (registerMap) {
    return API.getValueConfiguration(registerMap);
});

module.exports = {
    Model: Value,
    Collection: ValueCollection,

    fromSpec: fromSpec,
    isRegHK1: isRegHK1,
};
